import { render, staticRenderFns } from "./UtilVerifiedBadge.vue?vue&type=template&id=5aebd82b&scoped=true"
import script from "./UtilVerifiedBadge.vue?vue&type=script&lang=js"
export * from "./UtilVerifiedBadge.vue?vue&type=script&lang=js"
import style0 from "./UtilVerifiedBadge.vue?vue&type=style&index=0&id=5aebd82b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aebd82b",
  null
  
)

export default component.exports